/** @format */

export class GbSyncAuctionDataService {
    constructor(
        $rootScope,
        $log,
        $q,
        $gbAuctionImage,
        $gbItem,
        $gbBiddingItem,
        $gbDonationItem,
        $gbRaffleItem,
        $gbPurchaseItem,
        $gbRaffleDraw,
        $gbProjectorTemplate
    ) {
        'ngInject';

        this.$rootScope = $rootScope;
        this.$log = $log;
        this.$q = $q;
        this.$gbAuctionImage = $gbAuctionImage;
        this.$gbItem = $gbItem;
        this.$gbBiddingItem = $gbBiddingItem;
        this.$gbDonationItem = $gbDonationItem;
        this.$gbRaffleItem = $gbRaffleItem;
        this.$gbPurchaseItem = $gbPurchaseItem;
        this.$gbRaffleDraw = $gbRaffleDraw;
        this.$gbProjectorTemplate = $gbProjectorTemplate;

        this.auctionDataSynched = false;
        this.$allDataSynched = '$allDataSynced';
        this.$resourceSynched = '$resourceSynced';
        this.fetched = {};

        let urlParams = new URLSearchParams(window.location.search);
        this.isEditMode = () => urlParams.get('editMode') === 'true';
    }

    syncResource(resource, params, label) {
        return resource
            .query(params)
            .$promise.then((data) => {
                this.$log.info('Synched Resource', data);
                resource.cache.clear();
                resource.cache.push(data);
                this.$rootScope.$broadcast(`${this.$resourceSynched}.${label}`);
            })
            .finally(() => {
                this.fetched[label] = true;
            });
    }

    syncAllResources(url_name) {
        let promises = [
            this.syncResource(
                this.$gbItem,
                {
                    url_name,
                    expand: '1',
                },
                '$gbItem'
            ),
            this.syncResource(
                this.$gbBiddingItem,
                {
                    url_name,
                },
                '$gbBiddingItem'
            ),
            this.syncResource(
                this.$gbDonationItem,
                {
                    url_name,
                },
                '$gbDonationItem'
            ),
            this.syncResource(
                this.$gbRaffleItem,
                {
                    url_name,
                },
                '$gbRaffleItem'
            ),
            this.syncResource(
                this.$gbPurchaseItem,
                {
                    auction: url_name,
                },
                '$gbPurchaseItem'
            ),
            this.syncResource(
                this.$gbRaffleDraw,
                {
                    auction: url_name,
                },
                '$gbRaffleDraw'
            ),
        ];

        if (this.isEditMode()) {
            promises.push(this.syncResource(this.$gbProjectorTemplate, {}, '$gbProjectorTemplate'));
        }

        return this.$q.all(promises).then((data) => {
            this.$rootScope.$broadcast(this.$allDataSynched);

            return data;
        });
    }
}
